export default __webpack_public_path__ + "static/media/colorSplotchFree.e79de243.svg";